if (!customElements.get('bw-hero-carousel')) {
  customElements.define('bw-hero-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.slides = Array.from(this.querySelectorAll('.bw-hero'));
      this.index = 0;
      this.querySelector('.bw-hero-carousel__controls').hidden = false;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-direction]');
        if (button) this.show(this.index + Number(button.dataset.direction), true);
      }, options);
      // Keep a focused slide link visible until keyboard focus leaves it.
      this.addEventListener('focusin', () => this.schedule(), options);
      this.addEventListener('focusout', () => queueMicrotask(() => this.schedule()), options);
      this.addEventListener('keydown', (event) => {
        if (!event.target.closest('.bw-hero-carousel__controls')) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
        }
      }, options);
      this.addEventListener('touchstart', (event) => {
        if (event.touches.length === 1) this.touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
      }, { ...options, passive: true });
      this.addEventListener('touchend', (event) => {
        if (!this.touchStart || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - this.touchStart.x;
        const dy = event.changedTouches[0].clientY - this.touchStart.y;
        this.touchStart = null;
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) this.show(this.index + (dx < 0 ? 1 : -1), true);
      }, { ...options, passive: true });
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.show(0);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abort?.abort();
      this.abort = null;
    }
    show(index, manual = false) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
        if (active) slide.querySelectorAll('img').forEach(image => image.loading = 'eager');
      });
      if (manual) {
        this.querySelector('[data-status]').textContent = this.slides[this.index].getAttribute('aria-label');
      }
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.isConnected && this.dataset.autoplay === 'true' && !document.hidden && !this.slides[this.index].contains(document.activeElement)) this.timer = setTimeout(() => this.show(this.index + 1), 7000);
    }
  });
}
